import React from 'react';
import styled from 'styled-components';
import { Block } from '../../../../components';
import ClockIcon from '../../../../../assets/icons/resources/clock.svg';
import CalendarIcon from '../../../../../assets/icons/resources/calendar.svg';
import LocationIcon from '../../../../../assets/icons/resources/location.svg';
import ClockDisabledIcon from '../../../../../assets/icons/resources/clock-disabled.svg';
import CalendarDisabledIcon from '../../../../../assets/icons/resources/calendar-disabled.svg';
import LocationDisabledIcon from '../../../../../assets/icons/resources/location-disabled.svg';
import { CardBody, CardHeader } from './ReservedStyledComponents';

interface ReservedCardProps {
  onClick: () => void;
  title: string;
  reservationDate: string;
  reservationTime: string;
  reservationLocation: string;
  disabled?: boolean;
}

const Container = styled.button.attrs((props: any) => ({
  width: props.width
}))`
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  min-width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
  flex-direction: column;
  cursor: pointer;
  &:hover {
    background-color: var(--buton-icon-hover);
  }
  &:focus {
    background-color: var(--button-icon-focus);
  }
  &:disabled {
    cursor: default;
    background: #fff;
  }
`;

const ReservedCard = (props: ReservedCardProps) => {
  const {
    onClick,
    title,
    reservationDate,
    reservationTime,
    reservationLocation,
    disabled
  } = props;
  return (
    <Container
      onClick={onClick}
      type="button"
      className="fadeTransition"
      data-testid="cmp-procedure-reserved"
      disabled={disabled}
    >
      <CardHeader>
        <div className={disabled ? 'headerTitleDisabled' : 'headerTitle'}>
          {title}
        </div>
      </CardHeader>
      <Block customized height="1px" width="100%" backgroundColor="#D5E5F0" />
      <CardBody>
        <div
          className={disabled ? 'disabled' : ''}
          style={{ display: 'flex', marginBottom: '8px' }}
        >
          <img
            src={disabled ? CalendarDisabledIcon : CalendarIcon}
            alt="CalendarIcon"
          />
          <div>{reservationDate}</div>
        </div>
        <div
          className={disabled ? 'disabled' : ''}
          style={{ display: 'flex', marginBottom: '8px' }}
        >
          <img src={disabled ? ClockDisabledIcon : ClockIcon} alt="ClockIcon" />
          <div>{reservationTime}</div>
        </div>
        <div
          className={disabled ? 'disabled' : ''}
          style={{ display: 'flex', marginBottom: '4px' }}
        >
          <img
            src={disabled ? LocationDisabledIcon : LocationIcon}
            alt="LocationIcon"
          />
          <div>{reservationLocation}</div>
        </div>
      </CardBody>
    </Container>
  );
};

export default ReservedCard;
